import { useEffect, useState } from "react";
import { fetchSiteContent, updateSiteContent } from "../api/tcg";
import { CONTENT_SECTIONS } from "../data/siteContent.default";

function AdminContent({ token }: { token: string }) {
    const [values, setValues] = useState<Record<string, string>>({});
    const [message, setMessage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [busy, setBusy] = useState(false);

    async function load() {
        try {
            const stored = await fetchSiteContent();
            const next: Record<string, string> = {};
            for (const section of CONTENT_SECTIONS) {
                for (const field of section.fields) {
                    next[field.key] = stored[field.key] ?? field.default;
                }
            }
            setValues(next);
        } catch (err) {
            setError(err instanceof Error ? err.message : "Konnte Inhalte nicht laden.");
        }
    }

    useEffect(() => { load(); }, []);

    function update(key: string, value: string) {
        setValues((prev) => ({ ...prev, [key]: value }));
    }

    async function handleSave() {
        setBusy(true); setMessage(null); setError(null);
        try {
            await updateSiteContent(token, values);
            setMessage("Texte gespeichert.");
        } catch (err) {
            setError(err instanceof Error ? err.message : "Speichern fehlgeschlagen.");
        } finally { setBusy(false); }
    }

    return (
        <section className="admin-card">
            <h2 className="admin-card-title">Startseiten-Texte</h2>
            <p className="admin-note" style={{ marginBottom: "18px" }}>
                Überschriften und Beschreibungen der Startseite. Ein leeres Feld bedeutet: Standardtext wird verwendet.
            </p>

            {message && <p className="admin-success">{message}</p>}
            {error && <p className="admin-error">{error}</p>}

            {CONTENT_SECTIONS.map((section) => (
                <div className="admin-action-block" key={section.title}>
                    <h3 className="admin-subtitle">{section.title}</h3>
                    {section.fields.map((field) => (
                        <div key={field.key} style={{ marginBottom: "14px" }}>
                            <label className="admin-label">{field.label}</label>
                            {field.multiline ? (
                                <textarea
                                    className="admin-input"
                                    rows={3}
                                    value={values[field.key] ?? ""}
                                    onChange={(e) => update(field.key, e.target.value)}
                                    style={{ width: "100%", boxSizing: "border-box", resize: "vertical" }}
                                />
                            ) : (
                                <input
                                    className="admin-input"
                                    type="text"
                                    value={values[field.key] ?? ""}
                                    onChange={(e) => update(field.key, e.target.value)}
                                    style={{ width: "100%", boxSizing: "border-box" }}
                                />
                            )}
                        </div>
                    ))}
                </div>
            ))}

            <button className="admin-btn-primary" onClick={handleSave} disabled={busy}>
                {busy ? "Speichert…" : "Speichern"}
            </button>
        </section>
    );
}

export default AdminContent;
